/**
 * SEO优化工具
 * 为Vue SPA提供更好的SEO支持
 */

// 页面SEO数据配置
const SEO_DATA = {
  '/': {
    title: '湖北智寰科技官网 - 七鼠智服AI智能客服系统 | 电商客服解决方案专家',
    description: '湖北智寰科技专注AI智能客服系统研发，七鼠智服基于千亿大模型，为电商企业提供智能客服解决方案。支持图像识别、语音解析、多平台管理，助力企业降本增效，提升客户满意度。',
    keywords: '湖北智寰科技,智寰科技官网,七鼠智服,七鼠智服官网,AI智能客服,电商客服系统,人工智能客服,智能客服解决方案,客服机器人,AI大模型',
    content: '湖北智寰科技是专业的AI智能客服系统提供商，主要产品七鼠智服基于千亿大模型，为电商企业提供全方位的智能客服解决方案。'
  },
  '/product': {
    title: '七鼠智服官网 - AI智能客服系统产品介绍 | 湖北智寰科技',
    description: '七鼠智服是湖北智寰科技基于千亿大模型开发的AI智能客服系统，支持图像识别、语音解析、商品链接处理，为电商企业提供7*24小时智能客服服务。',
    keywords: '七鼠智服,七鼠智服官网,AI智能客服系统,电商客服,智能客服产品,图像识别客服,语音客服,湖北智寰科技',
    content: '七鼠智服AI智能客服系统具备图像识别、语音解析、商品链接处理等核心功能，为电商企业提供专业的智能客服服务。'
  },
  '/about': {
    title: '关于湖北智寰科技 - AI人工智能技术研发公司 | 智寰科技官网',
    description: '湖北智寰科技专注人工智能核心技术研发与应用，致力于助力企业智能化升级。公司位于华中地区，为各行业量身打造智能化解决方案。',
    keywords: '湖北智寰科技,智寰科技官网,关于智寰科技,人工智能公司,AI技术研发,企业智能化升级,华中地区,武汉',
    content: '湖北智寰科技专注人工智能技术研发，拥有强大的技术团队，专注于计算机视觉、深度学习等AI核心技术。'
  },
  '/price': {
    title: '七鼠智服价格方案 - AI智能客服系统报价 | 湖北智寰科技官网',
    description: '湖北智寰科技七鼠智服AI智能客服系统价格方案，提供多种套餐选择，满足不同规模电商企业需求。',
    keywords: '七鼠智服价格,七鼠智服官网,AI智能客服价格,智能客服系统报价,电商客服价格,湖北智寰科技',
    content: '湖北智寰科技提供灵活的七鼠智服价格方案，满足不同规模电商企业的智能客服需求。'
  },
  '/download': {
    title: '七鼠智服下载 - AI智能客服系统软件下载 | 湖北智寰科技官网',
    description: '下载湖北智寰科技七鼠智服AI智能客服系统，支持Windows、iOS、Android等多平台。免费试用，快速部署。',
    keywords: '七鼠智服下载,七鼠智服官网,AI智能客服下载,智能客服系统下载,电商客服软件,湖北智寰科技',
    content: '七鼠智服支持多平台下载，包括Windows、iOS、Android等，提供免费试用版本。'
  }
}

// 检测是否为搜索引擎爬虫
export function isSearchBot() {
  if (typeof navigator === 'undefined') return false

  const userAgent = navigator.userAgent.toLowerCase()
  const bots = [
    'baiduspider',
    'sogou',
    '360spider',
    'bytespider',
    'googlebot',
    'bingbot',
    'wechatbot',
    'qqbot',
    'weibobot',
    'facebookexternalhit',
    'twitterbot'
  ]

  return bots.some(bot => userAgent.includes(bot))
}

// 更新页面SEO信息
export function updatePageSEO(route) {
  const seoData = SEO_DATA[route] || SEO_DATA['/']

  // 更新页面标题
  document.title = seoData.title

  // 更新meta标签
  updateMetaTag('description', seoData.description)
  updateMetaTag('keywords', seoData.keywords)

  // 更新微信分享标签
  updateMetaTag('og:title', seoData.title, 'property')
  updateMetaTag('og:description', seoData.description, 'property')
  updateMetaTag('og:url', `https://zhihuanai.com${route}`, 'property')

  // 更新QQ分享标签
  updateMetaTag('name', seoData.title, 'itemprop')
  updateMetaTag('description', seoData.description, 'itemprop')

  // 更新微博分享标签
  updateMetaTag('weibo:title', seoData.title)
  updateMetaTag('weibo:description', seoData.description)
}

// 为搜索引擎提供静态内容
export function provideSEOContent() {
  const route = window.location.pathname
  const seoData = SEO_DATA[route] || SEO_DATA['/']

  // 立即更新页面SEO信息
  updatePageSEO(route)

  // 为搜索引擎爬虫添加额外的静态内容
  if (isSearchBot()) {
    addStaticContent(seoData.title, seoData.content)
  }
}

function updateMetaTag(name, content, attribute = 'name') {
  let element = document.querySelector(`meta[${attribute}="${name}"]`)
  if (element) {
    element.setAttribute('content', content)
  } else {
    element = document.createElement('meta')
    element.setAttribute(attribute, name)
    element.setAttribute('content', content)
    document.getElementsByTagName('head')[0].appendChild(element)
  }
}

function addStaticContent(title, content) {
  // 添加隐藏的SEO内容，搜索引擎可以读取但用户看不到
  if (!document.querySelector('.seo-hidden-content')) {
    const seoDiv = document.createElement('div')
    seoDiv.className = 'seo-hidden-content'
    seoDiv.style.position = 'absolute'
    seoDiv.style.left = '-9999px'
    seoDiv.style.width = '1px'
    seoDiv.style.height = '1px'
    seoDiv.style.overflow = 'hidden'

    seoDiv.innerHTML = `
      <h1>${title}</h1>
      <p>${content}</p>
      <div>
        <span>湖北智寰科技</span>
        <span>智寰科技官网</span>
        <span>七鼠智服</span>
        <span>七鼠智服官网</span>
        <span>AI智能客服</span>
        <span>电商客服系统</span>
        <span>人工智能客服</span>
        <span>智能客服解决方案</span>
        <span>客服机器人</span>
        <span>AI大模型</span>
        <span>华中地区</span>
        <span>武汉</span>
        <span>深度学习</span>
        <span>自然语言处理</span>
      </div>
    `

    document.body.appendChild(seoDiv)
  }
}

// 页面加载完成后的SEO优化
export function enhanceSEO() {
  // 监听路由变化
  if (window.history && window.history.pushState) {
    const originalPushState = window.history.pushState
    window.history.pushState = function (...args) {
      originalPushState.apply(window.history, args)
      setTimeout(() => {
        updatePageSEO(window.location.pathname)
      }, 100)
    }
  }

  // 确保页面有基本的SEO内容
  setTimeout(() => {
    const route = window.location.pathname
    const seoData = SEO_DATA[route] || SEO_DATA['/']
    addStaticContent(seoData.title, seoData.content)
  }, 1000)
}
